import { useState, useEffect } from 'react';

export const useMediaMatchers = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkSize = () => {
      setIsMobile(window.innerWidth < 640);
      setIsTablet(window.innerWidth >= 640 && window.innerWidth < 1024);
      setIsDesktop(window.innerWidth >= 1024);
    };

    // Initial check
    if (typeof window !== 'undefined') {
      checkSize();
      window.addEventListener('resize', checkSize);
    }

    // Cleanup
    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', checkSize);
      }
    };
  }, []);

  return { isMobile, isTablet, isDesktop };
};
